import styled from "styled-components";
import {
  BASIC_BLACK,
  BASIC_BROWN,
  BASIC_DARK_GRAY,
  BASIC_WHITE,
  BASIC_YELLOW,
} from "../../../constants/colors";

type Props = {
  id?: number;
  selected: boolean;
  categoryName: string;
  onClick: () => void;
};

export const MenuCategoryItem: React.FC<Props> = ({
  id,
  selected,
  categoryName,
  onClick,
}) => {
  return (
    <MenuCategoryItemContainer
      $selected={selected}
      onClick={onClick}
      id={`category-${id}`}
    >
      <MenuCategoryItemText $selected={selected} id={`category-text-${id}`}>
        {categoryName}
      </MenuCategoryItemText>
    </MenuCategoryItemContainer>
  );
};
const MenuCategoryItemContainer = styled.div<{ $selected: boolean }>`
  padding: 11px 14px;
  margin: 20px 0px;
  display: inline-block;
  border-radius: 100px;
  color: ${BASIC_DARK_GRAY};
  cursor: pointer;
  &:nth-of-type(1) {
    margin-left: 18px;
  }
  background-color: ${({ $selected }) =>
    $selected ? BASIC_YELLOW : "transparent"};
`;
const MenuCategoryItemText = styled.div<{ $selected: boolean }>`
  padding: 0;
  margin: 0;
  font-size: 16px;
  font-weight: 300;
  color: ${({ $selected }) => ($selected ? BASIC_BLACK : BASIC_DARK_GRAY)};
  font-weight: ${({ $selected }) => ($selected ? 500 : 300)};
`;
